import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data/config';
import { useAnalytics } from '../hooks/useAnalytics';

const Footer = () => {
  const { trackExternalLink } = useAnalytics();

  const handleSocialClick = (platform) => {
    trackExternalLink(platform, siteConfig.socialLinks[platform]);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{siteConfig.name}</h3>
            <p>{siteConfig.title}</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              {siteConfig.navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <a href={siteConfig.socialLinks.twitter} target="_blank" rel="noopener noreferrer" onClick={() => handleSocialClick('twitter')}>
                <i className="fab fa-twitter"></i>
              </a>
              <a href={siteConfig.socialLinks.bluesky} target="_blank" rel="noopener noreferrer" onClick={() => handleSocialClick('bluesky')}>
                <i className="fas fa-cloud"></i>
              </a>
              <Link to="/contact" onClick={() => trackExternalLink('contact_email', '/contact')}>
                <i className="fas fa-envelope"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 {siteConfig.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// Footer doesn't receive props, so no PropTypes needed
// But we can add PropTypes for any future props if needed

export default Footer;
